import {
  TableBase,
  TableHeader,
  TableBody,
  TableHeaderCell,
  TableRow,
  TableCell,
  TextSemiBold,
  ControlledInput
} from '@hm/fundamental'
import {Controller, UseFormReturn} from 'react-hook-form'
import {Trans, useTranslation} from 'react-i18next'

import {
  BrickCalculationSectionDTO,
  EditMaterialInstallationForm
} from '@refra/modules/refra-planning/types'

interface BrickCalculationSectionTableProps {
  section: BrickCalculationSectionDTO
  sectionIndex: number
  formMethods: UseFormReturn<EditMaterialInstallationForm>
  isReadOnly?: boolean
}
export const BrickCalculationSectionTable = ({
  section,
  sectionIndex,
  formMethods,
  isReadOnly
}: BrickCalculationSectionTableProps) => {
  const {t} = useTranslation()

  return (
    <TableBase>
      <TableHeader>
        <TableHeaderCell>
          <Trans
            i18nKey="refraPlanning.brickCalculation.table.fromToInfo"
            values={{
              fromMeter: section.fromMeter,
              toMeter: section.toMeter
            }}
          />
        </TableHeaderCell>
        <TableHeaderCell>{t('refraPlanning.brickCalculation.table.piecePerRing')}</TableHeaderCell>
        <TableHeaderCell>{t('refraPlanning.brickCalculation.table.pieceTotal')}</TableHeaderCell>
        <TableHeaderCell>{t('refraPlanning.brickCalculation.table.kgPiece')}</TableHeaderCell>
        <TableHeaderCell>{t('refraPlanning.brickCalculation.table.kgTotal')}</TableHeaderCell>
      </TableHeader>
      <TableBody>
        {section.shapes.map((shape, shapeIndex) => {
          const rings = Number(((section.toMeter - section.fromMeter) / 0.2).toFixed())
          const numberOfBricksPerRing = formMethods.watch(
            `brickCalculations.sections.${sectionIndex}.shapes.${shapeIndex}.numberOfBricksPerRing`
          )
          const brickWeightKg = formMethods.watch(
            `brickCalculations.sections.${sectionIndex}.shapes.${shapeIndex}.brickWeightKg`
          )
          const numberOfBricks = numberOfBricksPerRing
            ? numberOfBricksPerRing * rings
            : shape.numberOfBricks

          const weightKg = brickWeightKg ? brickWeightKg * numberOfBricks : shape.weightKg
          return (
            <TableRow key={`shape-${shapeIndex}`}>
              <TableCell>{shape.name}</TableCell>
              <TableCell>
                <Controller
                  name={`brickCalculations.sections.${sectionIndex}.shapes.${shapeIndex}.numberOfBricksPerRing`}
                  control={formMethods.control}
                  render={({field}) => (
                    <ControlledInput
                      {...field}
                      type="number"
                      value={field.value?.toString() ?? ''}
                      isDisabled={isReadOnly}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                    />
                  )}
                />
              </TableCell>
              <TableCell>{numberOfBricks}</TableCell>
              <TableCell>
                <Controller
                  name={`brickCalculations.sections.${sectionIndex}.shapes.${shapeIndex}.brickWeightKg`}
                  control={formMethods.control}
                  render={({field}) => (
                    <ControlledInput
                      {...field}
                      type="number"
                      value={field.value?.toString() ?? ''}
                      isDisabled={isReadOnly}
                      onChange={(e) => field.onChange(Number(e.target.value))}
                    />
                  )}
                />
              </TableCell>
              <TableCell>{weightKg.toFixed(2)}</TableCell>
            </TableRow>
          )
        })}
        <TableRow>
          <TableCell>
            <TextSemiBold>{t('refraPlanning.brickCalculation.table.totalBricks')}</TextSemiBold>
          </TableCell>
          <TableCell>{section.numberOfBricks}</TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell>{section.weightKg.toFixed(2)}</TableCell>
        </TableRow>
      </TableBody>
    </TableBase>
  )
}
